import { render, staticRenderFns } from "./text-formatter.vue?vue&type=template&id=28b169d8&"
import script from "./text-formatter.vue?vue&type=script&lang=ts&"
export * from "./text-formatter.vue?vue&type=script&lang=ts&"
import style0 from "./text-formatter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports